import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRequest, useClickAway } from 'ahooks';
import { MenuOutlined } from '@ant-design/icons';
import { Anchor, Row, Col } from 'antd';
import { request } from '@/config/request';
import { ProductCategoryFrontendRespDTO } from '@/service/goods';
import { isLogin } from '@/config/request/login';
import './index.scss';
interface CategoryProps {
    changeParams: () => void;
}
const Category = ({ changeParams }: CategoryProps) => {
    const ref = useRef(null);
    const navigate = useNavigate();
    const login = isLogin();
    // 获取类目
    const { runAsync: apiGetCategory, loading } = useRequest(
        request.goods.productCategoryFrontend.tree,
        {
            manual: true
        }
    );
    // 展示子类目modal
    const [showSubdirectory, setShowSubdirectory] = useState<boolean>(false);
    // 鼠标悬浮的类目
    const [hoverItem, setHoverItem] = useState<any>({});
    // 类目列表
    const [categoryList, setCategoryList] = useState<
        ProductCategoryFrontendRespDTO[]
    >([]);
    const [otherCategoryList, setOtherCategoryList] = useState<
        ProductCategoryFrontendRespDTO[]
    >([]);
    const [showOther, setShowOther] = useState<boolean>(false);
    const [anchorList, setAnchorList] = useState([]);
    useEffect(() => {
        apiGetCategory({
            stationCode: 'JapanStation'
        }).then((res) => {
            // 类目列表的前8个类目放到categoryList中，剩余的放入otherCategoryList，用于展示
            setCategoryList(res?.data || []);
            // setOtherCategoryList(res?.data?.slice(8) || []);
        });
    }, [apiGetCategory, login]);

    // 其他类目筛选
    useEffect(() => {
        const parentElement = document.getElementById('category-list');
        const childElements = parentElement?.children || [];
        let sliceIndex = 0;
        for (let i = 0; i < childElements.length; i++) {
            const child = childElements[i] as HTMLElement;
            if (!childElements[i + 1]) {
                break;
            }
            const nextChild = childElements[i + 1] as HTMLElement;
            if (child.offsetLeft > nextChild.offsetLeft) {
                sliceIndex = i + 1;
                break;
            }
        }
        if (sliceIndex !== 0) {
            const list = categoryList.slice(sliceIndex);
            setOtherCategoryList(list || []);
            // TODO 使用map
            const itemList: any = [];
            list.forEach((item) => {
                itemList.push({
                    key: String(item.productCategoryFrontendId),
                    href: `#${item.productCategoryFrontendId}`,
                    title: item.cateNameJp
                });
            });
            setAnchorList(itemList);
        }
    }, [categoryList]);
    useClickAway(() => {
        setShowOther(false);
    }, ref);
    // 类目点击
    const categoryClick = (id: number, name: string) => {
        setShowOther(false);
        navigate(
            `/goodsList?productCategoryFrontendId=${id}&cateNameJp=${name}`
        );
        changeParams();
    };
    // TODO类目render抽取
    return (
        <div className="category" ref={ref}>
            <div
                id="category-list"
                className="w-[1016px] h-[26px] overflow-hidden"
            >
                {categoryList.map((item, index) => (
                    <span
                        className="category-item"
                        key={index}
                        onMouseOver={() => {
                            if (showOther) return;
                            setHoverItem(item);
                            setShowSubdirectory(true);
                        }}
                        onMouseOut={() => {
                            setShowSubdirectory(false);
                        }}
                        onClick={() =>
                            categoryClick(
                                item.productCategoryFrontendId!,
                                item.cateNameJp!
                            )
                        }
                    >
                        <span className="category-item-title">
                            {item.cateNameJp}
                        </span>
                        <span
                            onMouseOver={() => {
                                if (showOther) return;
                                setHoverItem(item);
                                setShowSubdirectory(true);
                            }}
                            className="w-[100%] h-[40px] block"
                        />
                    </span>
                ))}
            </div>
            {otherCategoryList.length > 0 && (
                <span
                    className="category-other"
                    onClick={() => {
                        setShowOther(!showOther);
                    }}
                >
                    {window._$m.t('其他分类')}
                    <MenuOutlined className="ml-[4px]" />
                </span>
            )}
            <div
                className="category-sub shadow-lg"
                onMouseOver={() => {
                    if (showOther) return;
                    setShowSubdirectory(true);
                }}
                onMouseOut={() => {
                    setShowSubdirectory(false);
                }}
                style={{
                    display: showSubdirectory ? 'block' : 'none'
                }}
            >
                <div
                    onClick={() =>
                        categoryClick(
                            hoverItem.productCategoryFrontendId!,
                            hoverItem.cateNameJp!
                        )
                    }
                    className="text-[#FF5010FF] text-base category-tag"
                >
                    {hoverItem.cateNameJp}
                </div>
                <div className="flex flex-wrap">
                    {hoverItem &&
                        hoverItem.children &&
                        hoverItem.children.map((item, index) => {
                            return (
                                <div key={index} className="category-second ">
                                    <div
                                        onClick={() =>
                                            categoryClick(
                                                item.productCategoryFrontendId!,
                                                item.cateNameJp!
                                            )
                                        }
                                        className="mb-[8px] category-tag"
                                    >
                                        {item.cateNameJp}
                                    </div>
                                    <div className="w-[452px] h-[1px] bg-[#E6EAF0FF]" />
                                    <div>
                                        {item.children &&
                                            item.children.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className="category-third category-tag"
                                                        onClick={() =>
                                                            categoryClick(
                                                                item.productCategoryFrontendId!,
                                                                item.cateNameJp!
                                                            )
                                                        }
                                                    >
                                                        {item.cateNameJp}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
            {showOther && (
                <div className="category-sub shadow-lg category-other-sub">
                    <Row>
                        <Col span={5} className="mr-[30px]">
                            <Anchor
                                bounds={30}
                                getContainer={() => {
                                    return (
                                        (document.getElementById(
                                            'category-other'
                                        ) as HTMLElement) || window
                                    );
                                }}
                                offsetTop={10}
                                items={anchorList}
                            />
                        </Col>
                        <Col span={18}>
                            <div
                                id="category-other"
                                className="overflow-y-auto h-[440px] overscroll-contain"
                            >
                                {otherCategoryList.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            id={String(
                                                item.productCategoryFrontendId
                                            )}
                                        >
                                            <div className="text-[#FF5010] text-[16px]">
                                                {item.cateNameJp}
                                            </div>
                                            <div className="category-second-box">
                                                {item.children?.map(
                                                    (item, index) => {
                                                        return (
                                                            <div
                                                                key={index}
                                                                className="category-second category-second-other"
                                                            >
                                                                <div
                                                                    onClick={() =>
                                                                        categoryClick(
                                                                            item.productCategoryFrontendId!,
                                                                            item.cateNameJp!
                                                                        )
                                                                    }
                                                                    className="mb-[8px] category-tag"
                                                                >
                                                                    {
                                                                        item.cateNameJp
                                                                    }
                                                                </div>
                                                                <div className="w-[300px] h-[1px] bg-[#E6EAF0FF]" />
                                                                <div>
                                                                    {item.children &&
                                                                        item.children.map(
                                                                            (
                                                                                item,
                                                                                index
                                                                            ) => {
                                                                                return (
                                                                                    <div
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                        className="category-third category-tag"
                                                                                        onClick={() =>
                                                                                            categoryClick(
                                                                                                item.productCategoryFrontendId!,
                                                                                                item.cateNameJp!
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            item.cateNameJp
                                                                                        }
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )}
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
};
export default Category;
